import {Injectable} from "@angular/core";
import {
  AllowanceEntity,
  BokkzClient,
  IncomeTaxEntity,
  Toeslagen,
  ToeslagenBerekening
} from './api.bokkz.services';
import { ErrorMessage, TslRekenService } from './rekenclient.api';
import {BokkzTslDataService} from "./bokkz-tsl-data-service";
import { ToastService } from '@snelstart/ui-toast';

@Injectable({providedIn: 'root'})
export class BokkzTslLogic {

  public errorResponse = {} as ErrorMessage[];
  public allowanceEntity = {} as AllowanceEntity;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public toeslagen = {} as Toeslagen;
  public tslBerekening = {} as ToeslagenBerekening;
  public aantalValidaties = {} as number;
  public errorString = '';

  constructor(private bokkzClient: BokkzClient,
              private tslRekenService: TslRekenService,
              private toastService: ToastService,
              public dataService: BokkzTslDataService,
  ) {
    this.dataService.allowanceEntity.subscribe((value) => (this.allowanceEntity = value));
    this.dataService.incomeTaxEntity.subscribe((value) => (this.incomeTaxEntity = value));
    this.dataService.tslBerekening.subscribe((value) => (this.tslBerekening = value));
    this.dataService.errorResponse.subscribe((value) => (this.errorResponse = value));
    this.dataService.aantalValidaties.subscribe((value) => (this.aantalValidaties = value));
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity() : AllowanceEntity {
    return this.getFromSessionStorage('allowanceEntity') || {} as AllowanceEntity;
  }

  public postAllowances(allowanceEntity: AllowanceEntity, sendToAuthorities: boolean) {
    if (allowanceEntity.sstRelationId !== undefined) {
      this.bokkzClient.postAllowance(allowanceEntity.sstRelationId!, sendToAuthorities, allowanceEntity).subscribe({
        next: (response) => {
          if (response && response.toeslagen != null) {
          }
        },
        error: (err) => {
          this.toastService.showSuccessMessage('De gegevens zijn niet opgeslagen.',);
          console.log(err)
        },
      })
    }
  }

  public getValidation(toeslagen: Toeslagen) {
    const validatieObject = this.getEntity();
    if (validatieObject.toeslagen && validatieObject.toeslagen.inkomensgegevens==undefined) {
        validatieObject.toeslagen.inkomensgegevens=[];
    }
    this.tslRekenService.getToeslagenValidation(validatieObject.toeslagen!).subscribe({
      next: (response) => {
        if (response.alOntvangenZorgtoeslag != null) {
          this.dataService.updateAantalValidaties(0);
          this.dataService.updateToeslagenBerekening(response as ToeslagenBerekening);
        } else {

          if ("HV000028: Unexpected exception during isValid call." === response as unknown as string) {
            this.errorString = response as unknown as string;
            const error: ErrorMessage[] = [{
              error: "server.error",
              response: "HV000028: Unexpected exception during isValid call."
            }]
            this.dataService.updateErrorResponse(error);
            this.dataService.updateAantalValidaties(1);
            this.dataService.updateToeslagenBerekening({});
          } else {
            this.dataService.updateErrorResponse(response as ErrorMessage[]);
            this.dataService.updateAantalValidaties(this.errorResponse.length);
            this.dataService.updateToeslagenBerekening({});
          }
        }
      },
      error: (err) => {
        this.dataService.updateAantalValidaties(0);
        console.log(err)
      },
      complete: () => console.log("complete")
    })
  }
}
